export function init() {
  console.log('[initialized] header');
  const header = document.querySelector('.header');
  const metaNav = document.querySelector('.meta-nav');
  const mainNavWrapper = document.querySelector('.header__nav__wrapper');

  if (!header) return;
  /**
   * Handles the scroll event and updates the header and meta navigation styles accordingly.
   */
  const onScroll = () => {
    const scrolled = window.scrollY > 0;
    header.classList.toggle('header--scrolled', scrolled);
    if (metaNav) {
      metaNav.classList.toggle('meta-nav--scrolled', scrolled);
    }
  };

  window.addEventListener('scroll', onScroll);

  /**
   * Toggles the mobile navigation menu and updates the corresponding attributes and classes.
   * @param e - The event object.
   * @param header - The header element.
   */
  const toggleMobileNavigation = (e: Event, header: Element) => {
    const mobileToggle = e.currentTarget as Element;
    header.classList.toggle('header--nav-open');
    const isActive = header.classList.contains('header--nav-open');
    mobileToggle.setAttribute('aria-expanded', isActive ? 'true' : 'false');

    if (mainNavWrapper) {
      mainNavWrapper.classList.toggle('header__nav__wrapper--open');
      // Block scrolling when mobile navigation is open
      document.querySelector('body')?.classList.toggle('no-scroll');
    }

    if (isActive) {
      mobileToggle.setAttribute('aria-label', 'Navigation schliessen');
    } else {
      mobileToggle.setAttribute('aria-label', 'Navigation öffnen');
    }
  };

  const mobileToggle = document.querySelector('.header__nav__mobile-toggle');
  if (!mobileToggle) return;
  // Set initial aria-label
  mobileToggle.setAttribute('aria-label', 'Navigation öffnen');
  mobileToggle.addEventListener('click', (e) =>
    toggleMobileNavigation(e, header),
  );
}
